// es_ES language file
// Generated from Feishu Bitable
// Total entries: 402

export default{
    "game_diamond": {
        "title": "Info de Diamantes de Juego",
        "title0_title": "Cómo conseguir Diamantes de Juego",
        "title0": {
            "txt1": "1. Gánalos en tareas o eventos específicos.",
            "txt2": "2. No se compran con recarga."
        },
        "title1_title": "Uso de los Diamantes de Juego",
        "title1": {
            "txt1": "1. Solo para juegos.",
            "txt2": "2. En el juego, los Diamantes de Juego equivalen a los diamantes normales y se usan directamente. Los que ganes con Diamantes de Juego serán normales.",
            "txt3": "3. Se usan primero los diamantes de juego.",
            "txt4": "4. Se combinan con diamantes. Ej.: 200 + 800 = 1000 gastados juntos."
        },
        "title2_title": "Vigencia de los Diamantes de Juego",
        "title2": {
            "txt1": "1. Tienen validez limitada y serán eliminados al expirar."
        }
    },
    "guanxi_gift_rule_title": "Descripción del regalo",
    "guanxi_gift_rule_1": "Después de enviar un regalo de relación, el destinatario puede elegir si desea formar una relación contigo. Solo puede haber una relación entre dos personas a la vez.",
    "guanxi_gift_rule_2": "Cada persona puede tener hasta 3 relaciones, y los tipos de relación pueden ser los mismos.",
    "guanxi_gift_rule_3": "Puedes terminar una relación 24 horas después de haberla formado. Después de terminar una relación, puedes formar una nueva después de otras 24 horas.",
    "not_exist": "No encontrado",
    "mbti_intro_title": "Descripciones MBTI",
    "mbti_intro_pers": "Rasgos de Personalidad",
    "mbti_intro_love": "Rasgos Románticos",
    "mbti_intro_istj_pers": "Personalidad del Inspector",
    "mbti_intro_istj_feature": "Serios, tranquilos, detallistas y precisos, prefieren una vida ordenada y estructurada. Confiables y responsables, siguen reglas y tradiciones.",
    "mbti_intro_istj_love": "En el amor, los ISTJ son compañeros leales y estables. Toman las relaciones en serio, centrándose en el compromiso y la responsabilidad, mostrando su cariño con acciones más que con palabras, y necesitan tiempo para formar conexiones profundas.",
    "mbti_intro_isfj_pers": "Personalidad del Cuidador",
    "mbti_intro_isfj_feature": "Amables, bondadosos y empáticos, son atentos a las necesidades de los demás y pacientes. Detallistas, son excelentes oyentes y apoyo constante.",
    "mbti_intro_isfj_love": "En relaciones, los ISFJ son profundamente atentos, cuidan los detalles de la vida de su pareja y crean un ambiente cálido y acogedor. Generalmente tradicionales, pueden tomarse su tiempo para comprometerse, pero son muy leales una vez que lo hacen.",
    "mbti_intro_infj_pers": "Personalidad del Arquitecto",
    "mbti_intro_infj_feature": "Perspicaces y creativos, con un profundo entendimiento de la humanidad y el futuro. Tienen una vida interior rica y son reflexivos y analíticos.",
    "mbti_intro_infj_love": "Los INFJ buscan una conexión mental y emocional con su pareja, valoran las conversaciones profundas. Tienen ideales altos en el amor y, cuando aman, son enfocados y devotos.",
    "mbti_intro_intj_pers": "Personalidad del Comandante",
    "mbti_intro_intj_feature": "Lógicos, tranquilos y seguros, con fuertes habilidades analíticas y de toma de decisiones, valoran el conocimiento y la sabiduría y persiguen sus metas tenazmente.",
    "mbti_intro_intj_love": "En relaciones, los INTJ abordan el amor racionalmente, valorando creencias y metas compartidas. Aunque reservados con las emociones, demuestran su cariño a través de acciones cuidadosas.",
    "mbti_intro_istp_pers": "Personalidad del Artesano",
    "mbti_intro_istp_feature": "Práctico, observador y analítico, disfruta de tareas manuales y de resolver problemas prácticos, especialmente en áreas mecánicas o técnicas.",
    "mbti_intro_istp_love": "Los ISTP son espontáneos y libres en las relaciones, disfrutando el momento presente con sus parejas y compartiendo los placeres de la vida sin muchas restricciones.",
    "mbti_intro_isfp_pers": "Personalidad del Artista",
    "mbti_intro_isfp_feature": "Sensibles, amables y artísticos, priorizan experiencias emocionales y sensoriales, a menudo expresándose a través de formas creativas.",
    "mbti_intro_isfp_love": "En relaciones, los ISFP son románticos y considerados, hábiles en crear un ambiente encantador, y a menudo sorprenden a sus parejas. Pueden ser emocionales y necesitan un compañero que los comprenda y apoye.",
    "mbti_intro_infp_pers": "Personalidad del Mediador",
    "mbti_intro_infp_feature": "Idealistas, amables y empáticos, tienen una rica vida interior y una profunda comprensión de la naturaleza humana, valorando la armonía y la belleza.",
    "mbti_intro_infp_love": "Los INFP invierten profundamente en las relaciones, buscando fuertes conexiones emocionales. Valoran los intercambios emocionales y comparten una visión esperanzadora del amor.",
    "mbti_intro_intp_pers": "Personalidad del Lógico",
    "mbti_intro_intp_feature": "Analíticos y curiosos, tienen un fuerte deseo de conocimiento, explorando áreas desconocidas en busca de la verdad.",
    "mbti_intro_intp_love": "En relaciones, los INTP son lógicos, centrándose en la compatibilidad intelectual y emocional. Aunque pueden ser reservados al expresar sus sentimientos, usan discusiones para fomentar el entendimiento mutuo.",
    "mbti_intro_estp_pers": "Personalidad del Emprendedor",
    "mbti_intro_estp_feature": "Enérgicos, extrovertidos y aventureros, disfrutan de las interacciones sociales y de tomar riesgos, aprovechando activamente las oportunidades.",
    "mbti_intro_estp_love": "En relaciones, los ESTP son vibrantes y apasionados, les encanta explorar nuevas experiencias con sus parejas. Son directos y expresan sus pensamientos y sentimientos abiertamente.",
    "mbti_intro_esfp_pers": "Personalidad del Intérprete",
    "mbti_intro_esfp_feature": "Extrovertidos, optimistas y expresivos, disfrutan socializando y entreteniéndose, aportando energía y entusiasmo.",
    "mbti_intro_esfp_love": "En el amor, los ESFP son compañeros animados que disfrutan de actividades sociales compartidas, enfatizando los sentimientos actuales y experiencias, trayendo alegría y emoción a sus parejas.",
    "mbti_intro_enfp_pers": "Personalidad del Defensor",
    "mbti_intro_enfp_feature": "Creativos, enérgicos y cálidos, les encanta interactuar con los demás y entienden profundamente las emociones ajenas.",
    "mbti_intro_enfp_love": "Los ENFP son como el sol en las relaciones, trayendo calidez y alegría a sus parejas. Llenos de romance, expresan activamente su amor y esperan crear hermosos recuerdos juntos.",
    "mbti_intro_entp_pers": "Personalidad del Debatiente",
    "mbti_intro_entp_feature": "Inteligentes, ingeniosos y curiosos, disfrutan debatiendo y explorando nuevas ideas y temas.",
    "mbti_intro_entp_love": "Los ENTP se involucran en discusiones profundas y debates con sus parejas, disfrutando del desafío y el crecimiento intelectual en el amor. A menudo juguetones, aportan humor a la relación.",
    "mbti_intro_estj_pers": "Personalidad Ejecutiva",
    "mbti_intro_estj_feature": "Prácticos, decididos y seguros, con fuertes habilidades organizativas y de liderazgo, priorizan la eficiencia y los resultados.",
    "mbti_intro_estj_love": "En el amor, los ESTJ son firmes y decididos, persiguiendo activamente sus intereses y planificando para el futuro. Muestran afecto a través de apoyo práctico y acciones.",
    "mbti_intro_esfj_pers": "Personalidad del Cónsul",
    "mbti_intro_esfj_feature": "Amistosos y cálidos, son sociables y se preocupan por los demás, valorando la tradición y los lazos familiares.",
    "mbti_intro_esfj_love": "Los ESFJ son compañeros atentos y cariñosos, creando un ambiente romántico y cálido. A menudo tradicionales, valoran las costumbres familiares de citas y la aprobación familiar.",
    "mbti_intro_enfj_pers": "Personalidad del Protagonista",
    "mbti_intro_enfj_feature": "Carismáticos y seguros, se conectan fácilmente y se comunican bien, entendiendo y guiando a los demás efectivamente.",
    "mbti_intro_enfj_love": "Los ENFJ son compañeros entusiastas y románticos, expresando abiertamente su amor y creando un ambiente cálido. Valoran el intercambio emocional y buscan formar un vínculo profundo con sus parejas.",
    "mbti_intro_entj_pers": "Personalidad Ejecutiva",
    "mbti_intro_entj_feature": "Lógicos, seguros y ambiciosos, con fuertes habilidades de liderazgo y toma de decisiones, valoran la excelencia y el éxito, manteniendo altos estándares para ellos y para los demás.",
    "mbti_intro_entj_love": "En el amor, los ENTJ están orientados a objetivos, eligiendo compañeros afines que apoyen el crecimiento mutuo. Priorizan la competencia y las ambiciones compartidas, profundizando las relaciones mediante metas comunes.",
    "expressProposalWall": "Muro de Declaraciones",
    "expressHowTo": "Cómo aparecer en el Muro de Declaraciones",
    "expressSend": "Entrega el regalo de declaración a tu amor. Tus palabras de amor se mostrarán en el muro de declaraciones.",
    "expressSend1": "1. Haz clic en \"Declarar ahora\" para ingresar a la página de la actividad y elige a la persona a la que quieres declarar tu amor.",
    "expressSend2": "2. Elige un regalo e ingresa lo que quieras decirle a él/ella en la tarjeta.",
    "expressSend3": "3. Haz clic en \"Enviar regalo\" y tu tarjeta de declaración se mostrará en el muro de declaraciones.",
    "expressDifferent": "Diferentes Tipos de el Regalo de Declaración",
    "expressWeHave": "Tenemos 4 tipos de Regalos de Declaración, como sigue.",
    "expressWeHave1": "1. Tarjeta de Regalo de Declaración Básica: Fondo de color simple.",
    "expressWeHave2": "2. Tarjeta de Regalo de Declaración Decorativa: Fondo colorido decorativo.",
    "expressWeHave3": "3. Tarjeta de Regalo de Declaración de Lujo: Fondo decorativo con efecto de lujo.",
    "expressWeHave4": "4. Tarjeta de Regalo de Declaración de Amor Verdadero: Fondo decorativo con efecto lujoso y acompañado de un anuncio en todo el servidor.",
    "expressProposal": "Rango de Visualización de la Tarjeta de Declaración",
    "expressProposal1": "1. Muro de Declaraciónes en la sala. (Haz clic en la barra encima del regalo de declaración)",
    "expressProposal2": "2. Muro de Declaraciónes junto a la página de Momentos.",
    "diamondDrop1": "1. Cuando un usuario envía regalos que suman más de 50,000 diamantes en una sala (los regalos de suerte se calculan al 10% del precio real del diamante), aparece un cofre de diamantes que cualquiera en la sala puede abrir para obtener diamantes.",
    "diamondDrop2": "2. Cada cofre tiene un tiempo de espera de 1 minuto antes de poder abrirse.",
    "diamondDrop3": "3. Los diamantes en cada cofre son limitados; una vez que termina la cuenta regresiva, ya no puedes reclamar diamantes de ese cofre.",
    "diamondDrop4": "4. Después de que el cofre se cierre, puedes hacer clic para ver cuántos diamantes obtuviste de él.",
    "baoxaingxianding": "宝箱限定",
    "cancelAccount": {
        "accountRecoveryContent": "Durante el período de recuperación, puedes iniciar sesión nuevamente usando tu método anterior y elegir recuperar tu cuenta. Una vez recuperada, recuperarás todos tus mensajes, niveles y diamantes de la cuenta.",
        "accountRecoveryTitle": "Recuperación de Cuenta:",
        "confirmCancellation": "¿Estás seguro de que quieres eliminar?",
        "convalescenceContent": "Después de enviar una solicitud de eliminación, tu cuenta será desactivada temporalmente por 30 días. Durante este tiempo, toda la información de tu cuenta, niveles y diamantes serán retenidos, permitiendo una recuperación sin problemas si cambias de opinión.",
        "convalescenceTitle": "Período de Recuperación:",
        "finalContent": "Si no eliges recuperar tu cuenta al final del período de recuperación (31 días desde la solicitud de eliminación), tu cuenta y todos los datos asociados serán eliminados permanentemente. Ten en cuenta que, una vez eliminados, tu cuenta y datos no podrán ser recuperados.",
        "finalTitle": "Eliminación Final:",
        "reserveContent": "Durante el período de recuperación, protegeremos los datos de tu cuenta para garantizar que no se pierdan o dañen.",
        "reserveTitle": "Retención de Datos:",
        "statementContent": "Solicitud de Eliminación: Después de enviar una solicitud de eliminación de cuenta, tu cuenta entrará en un \"período de recuperación\" de 30 días. Durante este tiempo, puedes optar por recuperar tu cuenta en cualquier momento. Si eres parte de una agencia, la eliminación de la cuenta no será posible.",
        "statementTitle": "Aviso de Eliminación de Cuenta:",
        "userContent": "Gracias por usar nuestros servicios. Entendemos que a veces puedes necesitar eliminar tu cuenta. Para asegurarnos de que tu decisión esté bien pensada y para proporcionar una oportunidad de reconsideración, describimos aquí el proceso de eliminación de cuenta y los términos relacionados.",
        "userTitle": "Estimado Usuario:"
    },
    "Countdown": "Cuenta Atrás",
    "Endactivity": "Evento Terminado",
    "eventDetails": "Detalles del Evento",
    "eventGifts": "Regalos del Evento",
    "eventList": "Tabla de Clasificación del Evento",
    "eventReward": "Recompensas del Evento",
    "eventRewards": {
        "player": "Jugadores Activos Diarios",
        "proportion": "Tasa de Retorno de Premios",
        "title": "Premios del Evento",
        "txt1": "1. Los datos del día anterior se calculan diariamente a las 00:00 (UTC+8).",
        "txt2": "2. Los premios se otorgan en función del número de participantes y los diamantes realmente gastados en la sala (apuestas del usuario menos otorgadas del usuario).",
        "txt3": "3. Los datos de la semana anterior se calculan todos los lunes a las 00:00 (UTC+8), y las recompensas se distribuyen dentro de los 3 días.",
        "txt4": "4. Tasa de Retorno de Premios:",
        "txt5": "5. Definición de Jugador Activo: Un jugador que apuesta más de 1.000 diamantes en un día."
    },
    "EventRules": "Reglas del Evento",
    "Eventtime": "Tiempo del Evento",
    "guild": {
        "guild_certification01": "Verificación de Agencia",
        "guild_certification02": "Bienvenida, Agencia",
        "guild_certification03": "Requisitos del reclutamiento",
        "guild_certification04": [
            "10 hosts firman contrato y se unen a la plataforma en una semana",
            "Capaz de proporcionar la identificación del agente y otros documentos con nombre real",
            "Proporcionar un perfil de la agencia, introducción del equipo, información de las hosts, reglas de ganancias de las hosts, etc."
        ],
        "guild_certification05": "Si cumples con los requisitos anteriores, envía tu información al correo electrónico oficial: \\n{s}\\nUna vez aprobado, un miembro del personal se pondrá en contacto contigo.",
        "guild_certification06": "Copiado al portapapeles",
        "guild_certification07": "Contacto para cooperación",
        "guild_certification08": "Copiar",
        "guild_certification09": "Información de Membresía",
        "guild_certification10": [
            {
                "title": "1. Reglas de Membresía",
                "value": [
                    "Los solicitantes deben acordar con el líder de la agencia para iniciar una solicitud de membresía en la plataforma. Una vez aprobados por el líder, se convierten en hosts firmados, contribuyendo a la agencia."
                ]
            },
            {
                "title": "2. Reglas de Renuncia",
                "value": [
                    "Para salir de la agencia después de unirte, hosts necesitan acordar con agente. Haz clic en \"Salir Agencia\" en la página de perfil de la agencia. El agente debe hacer clic en \"Aceptar Salida\" y luego el miembro saldrá de la agencia.",
                    "Después de que el retiro sea exitoso, puedes solicitar unirte a otra agencia."
                ]
            }
        ],
        "guild_certification11": "Información de la Agencia",
        "guild_certification12": [
            {
                "title": "Ganancias de la Agencia",
                "value": [
                    "Usuarios y hosts en las salas familiares reciben regalos, generando contribuciones para la agencia.",
                    "Ocurren ataques de Boss en las salas familiares.",
                    "Los hosts firmados con la agencia crean salas CP, y recibir regalos genera contribuciones para la agencia. (Los hosts no firmados no pueden crear salas CP y generar contribuciones para la familia después de unirse a la familia.)"
                ]
            }
        ],
        "InvitationCodeTitle": "Código de Invitación",
        "invite_rules_intriduction": "Reglas de Invitación",
        "invite_rules_intriduction_content": [
            "Los hosts pueden solicitar unirse a tu agencia y convertirse en hosts ingresando el código de invitación durante el registro.",
            "Los hosts que no ingresaron un código de invitación durante el registro pueden solicitar unirse a tu familia a través de la página de la familia, y luego solicitar convertirse en hosts."
        ]
    },
    "legend": {
        "title": "Febrero Legendario"
    },
    "officialMember": "Equipo Oficial",
    "prettyNumber": {
        "text": "Ⅰ. Recolección de ID Especial",
        "text1": "Después de alcanzar el Nivel 3 de Noble o superior, puedes reclamar un ID Especial correspondiente a tu nivel.",
        "text2": "Los Nobles de mayor nivel pueden reclamar un ID Especial de nivel inferior. Por ejemplo, un Noble 6 puede reclamar un ID Especial de Nivel 3.",
        "text3": "Cuando tu estado de Noble expira, el ID Especial también se vuelve inaccesible. Necesitas reactivar tu Noble para continuar usando el ID Especial.",
        "text5": "Una vez que reclames un ID Especial, no puedes cambiarlo por otro número del mismo nivel o inferior.",
        "text6": "Si alcanzas un nivel Noble superior mientras usas un ID Especial, puedes cambiar inmediatamente a un ID Especial de mayor nivel, y el ID original volverá a la tienda.",
        "text7": "Por ejemplo, un usuario Noble 4 que inicialmente reclama un ID Especial Noble 4 y luego se actualiza a Noble 6 no puede cambiar a un ID Especial Noble 4 o inferior, pero puede reclamar inmediatamente un ID Especial Noble 6.",
        "title": "Explicación",
        "title1": "Ⅱ. Expiración del ID Especial",
        "title2": "Ⅲ. Reemplazo del ID Especial"
    },
    "reception": {
        "reception01": "Explicación del Ranking de Regalos",
        "reception02": [
            {
                "title": "¿Qué es el Ranking de Regalos de la Sala?",
                "value": [
                    "El Ranking de Regalos de la Sala es una clasificación en tiempo real de los regalos recibidos en la sala",
                    "Recuento de regalos de la sala = Recuento de regalos de diamantes"
                ]
            },
            {
                "title": "¿Cómo se clasifica el Ranking de Regalos de la Sala?",
                "value": [
                    "La clasificación se determina en función de los ingresos totales de todas las salas, calculados de manera integral",
                    "Ranking por Hora: Se reinicia cada hora en UMT+8",
                    "Ranking Diario: Se reinicia a las 00:00 UMT+8 todos los días"
                ]
            },
            {
                "title": "El Top 1 en el Ranking por Hora se transmite a todo el servidor",
                "value": [
                    "La sala Top 1 en el ranking de regalos por hora se anuncia en todas las salas del servidor"
                ]
            }
        ]
    },
    "roomParty": {
        "back": "Regresar",
        "event_rule": "<p>1. Tabla de Duración: Rastrea el tiempo total que los usuarios pasan en todas las posiciones de micrófono de la sala durante el evento. Los 3 principales contribuyentes en las 3 principales salas recibirán recompensas.</p><p>2. Tabla de Generosidad: Rastrea el número total de diamantes recibidos en la sala durante el evento. Los 3 mayores gastadores de diamantes en las 3 principales salas recibirán recompensas.</p><p>3. Este evento es un evento de ciclo semanal, con la tabla de clasificación restableciéndose y recalculándose cada semana.</p>",
        "last_week": "La Semana Pasada",
        "last_week_rank": "Detalles del Ranking de la Semana Pasada",
        "reward": "Recompensas",
        "rich_rank": "Ranking de Regalos de la Sala",
        "rule": "Reglas",
        "rule_reward": "Reglas y Recompensas",
        "time_rank": "Tabla de Duración",
        "title": "Sala Familiar",
        "top1": "Top 1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_1_name": "Marco de Avatar por 14 días",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/mount/thunder_armor.png",
        "top1_pictures_2_name": "Efectos de Entrada por 14 días",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_3_name": "Marco de Avatar por 14 días",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_4_name": "Marco de Avatar por 7 días",
        "top2": "Top 2",
        "top3": "Top 3"
    },
    "TopUpRewards": "Recompensas de Recarga",
    "treasure_chest": {
        "title": "Instrucciones de Regalos del Cofre del Tesoro",
        "value1": "Hay tres tipos de cofres del tesoro: Madera, Plata y Oro.",
        "value2": "Al abrir un cofre del tesoro, recibirás un regalo al azar del cofre y lo enviarás.",
        "value3": "El remitente gana puntos de experiencia según los diamantes gastados, mientras que el destinatario recibe Monedas y puntos de encanto según el valor del regalo del cofre.",
        "value4": "Cofre de Madera, con un precio de 1500 diamantes, contiene los siguientes regalos:",
        "value5": "Cofre de Plata, con un precio de 7500 diamantes, contiene los siguientes regalos:",
        "value6": "Cofre de Oro, con un precio de 25000 diamantes, contiene los siguientes regalos:",
        "value7": "Los regalos del cofre del tesoro son solo para entretenimiento e interacción social. Cualquier acción que afecte la justicia o explote errores del producto estará prohibida. Si se detecta, la plataforma bloqueará la cuenta y se reserva el derecho de emprender acciones legales."
    },
    "treasure_name": {
        "name1": "Cofre de Madera",
        "name2": "Cofre de Plata",
        "name3": "Cofre de Oro",
        "name4": "Probabilidad"
    },
    "Value": "Valor:",
    "Webname": {
        "addUid": "Agregar UID",
        "balance": "Saldo:",
        "Confirm": "Confirmar",
        "err_uid": "UID no válido, por favor ingresa nuevamente",
        "lang": "Seleccionar Idioma",
        "Query": "Buscar",
        "recharge": "Centro de Recarga",
        "Recharge": "Recargar",
        "self": "Canal",
        "uid": "Cambiar UID",
        "uuserName": "Apodo:",
        "Withdrawal": "Retirar"
    },
    "Weekly_Cp": {
        "7days": "7 días",
        "back": "Volver",
        "countdown": "Cuenta atrás",
        "day": "días",
        "diamonds": "https://image.pocketliveapp.com/image/activity/New%20Folder/diamonds.png",
        "event_rule": "<p>Notas</p><p>1. Todas las recompensas se acreditarán en tu cuenta dentro de los 3-5 días hábiles después de que termine el evento.</p><p>2. La tabla de clasificación calcula los diamantes gastados en enviar regalos del evento a otros usuarios. 1 diamante = 1 punto CP, y las 3 parejas de CP con más puntos CP recibirán recompensas del evento.</p><p>3. El evento termina todos los lunes a las 00:00 (UTC+8), y se liquidan los valores de la semana anterior.</p><p>4. Solo se contará el 10% de los diamantes gastados en regalos de la suerte.</p>",
        "gift": "Regalos del Evento",
        "hour": "Hora",
        "last_week": "La semana pasada",
        "last_week_rank": "Lista de la semana pasada",
        "minute": "Minuto",
        "pocketcoins": "https://image.pocketliveapp.com/image/activity/New%20Folder/coins.png",
        "reward": "Recompensas",
        "rule": "Reglas",
        "rule_reward": "Reglas y Recompensas",
        "seconds": "Segundos",
        "title": "Soulmate",
        "top1": "TOP1",
        "top1_pictures_1": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top1_pictures_1_name": "Marco de Avatar de la Estrella Semanal",
        "top1_pictures_2": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top1_pictures_2_name": "Marco de Avatar de Mejor Apoyo",
        "top1_pictures_3": "https://cos.koudailive.com/image/goods/2011_cloth_female.png?t=1678879041",
        "top1_pictures_34_name": "Traje de la Estrella Semanal",
        "top1_pictures_4": "https://cos.koudailive.com/image/goods/2010_suit_male.png?t=1678879038",
        "top2": "TOP2",
        "top2_pictures_1": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top2_pictures_2": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top3": "TOP3",
        "top3_pictures_1": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top3_pictures_2": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top46": "TOP 4-6",
        "top710": "TOP 7-10"
    },
    "Withdrawal": "Instrucciones de Retiro",
    "withdrawalInstructions": {
        "text1": "La función de retiro está disponible actualmente solo en países seleccionados.",
        "text2": "El tiempo que toma procesar los retiros puede variar según el canal.",
        "text3": "El monto real recibido puede ser ligeramente inferior al monto mostrado debido a las fluctuaciones del tipo de cambio y las tarifas.",
        "text4": "Solo puedes retirar una vez al día.",
        "text5": "Si tienes algún problema, por favor contáctanos."
    },
    "withdrawalLogin": {
        "accountId": "ID de cuenta Pix",
        "accountIdTips": "",
        "accountIdtsa": "El ID de cuenta Pix no puede estar vacío",
        "accountType": "Tipo de cuenta Pix",
        "code": "Código de verificación:",
        "Confirm": "Confirmar",
        "documentId": "Número de identificación personal",
        "documentIdTips": "",
        "documentIdtsa": "El tipo de ID no puede estar vacío",
        "documentType": "Tipo de identificación",
        "getAccount": "Obtener cuenta",
        "getUserId": "Por favor, ingresa el ID de usuario",
        "incorrectAccount": "Cuenta incorrecta",
        "login": "Iniciar sesión",
        "loginSuccessful": "Inicio de sesión exitoso",
        "name": "Nombre de usuario Pix",
        "nameTips": "",
        "nametsa": "La longitud debe estar entre 5 y 100 caracteres",
        "officialGroup": "Si tienes alguna pregunta, por favor contacta a nuestro soporte oficial",
        "pocket": "Saldo de Monedas",
        "Pocket": "Saldo insuficiente de Monedas",
        "Send": "Enviar",
        "text": "El código de verificación se enviará dentro de la aplicación",
        "title": "Retiro de ganancias",
        "title2": "Detalles del retiro",
        "user_id": "ID de la Cuenta:",
        "Whatsapp": "Cuenta de Whatsapp incorrecta",
        "WhatsappTips": "",
        "applicationTime": "Fecha de Solicitud",
        "amount": "Monto a Retirar",
        "success": "Éxito",
        "applicationSuccess": "Solicitud Enviada"
    },
    "top1AnchorRewards": "Recompensa de Host Top 1",
    "top2_3AnchorRewards": "Recompensas de Host Top 2-3",
    "top4_10AnchorRewards": "Recompensas de Host Top 4-10",
    "top1Icon7day": "Marco de Avatar *7 Días",
    "top1_2Icon7day": "Efecto de Entrada *7 Días",
    "top3Icon7day": "Marco de Avatar *7 Días",
    "top1VIPRewards": "Premio VIP al mejor 1",
    "top2_3VIPRewards": "Top 2-3 premios VIP",
    "top4_10VIPRewards": "Top 4-10 premios VIP",
    "relastionship": {
        "des": [
            "",
            "1. Después de enviar un regalo de relación, la otra persona puede elegir si desea establecer una relación contigo. Solo puede existir un tipo de relación entre dos personas.",
            "2. Dentro de 7 días naturales (UTC+3) después de establecer la relación, la intimidad no se reducirá. Después del período de protección, si la intimidad no aumenta 50 puntos en un día, disminuirá un 10% a medianoche (mínimo 1). Cuando la intimidad llegue a 0, la relación se romperá a medianoche. Si no aumenta 50 puntos en 10 días seguidos, la relación terminará automáticamente.",
            "3. Puedes terminar la relación 24 horas después de formarla. Después de terminarla, puedes volver a establecerla 24 horas más tarde.",
            "4. Cada persona tiene 3 espacios de relación por defecto. Puedes gastar diamantes para comprar más, cada espacio cuesta 99.999 diamantes, y puedes comprar hasta 10. También puedes aumentar tus espacios subiendo tu nivel VIP.",
            "Nivel VIP",
            "Total de espacios de relación ampliables"
        ]
    },
    "gift_album_des1": "Enviar los regalos anteriores puede ayudarlo/la a desbloquear el Álbum Semanal - \"Viaje Mundial\" y obtener recompensas.",
    "gift_album_des2": "Enviar los regalos anteriores puede ayudarlo/la a desbloquear el Álbum Permanente - \"Foco Amoroso\" y obtener recompensas.",
    "gift_album_des3": "Enviar los regalos anteriores puede ayudarlo/la a desbloquear el Álbum Permanente - \"Guarda SVIP\" y obtener recompensas.",
    "gift_album_des4": "Enviar los regalos anteriores puede ayudarlo/la a desbloquear el Álbum Permanente - \"Boda Soñada\" y obtener recompensas.",
    "gift_album_des5": "Ve a [Perfil] - [Muro de Regalos] - [Álbum] para ver los detalles",
    "gift_harifata": "Burj Khalifa",
    "gift_sailing_hotel": "Burj Al Arab",
    "gift_mosque": "gran Mezquita",
    "gift_abatta": "Torre Abate",
    "gift_sphinx": "Esfinge",
    "svip_gift_1": "SVIP1",
    "svip_gift_2": "SVIP2",
    "svip_gift_3": "SVIP3",
    "svip_gift_4": "SVIP4",
    "svip_gift_5": "SVIP5",
    "svip_gift_6": "SVIP6",
    "gift_conf_lv1": "Corazón Latido",
    "gift_conf_lv2": "Enamoramiento",
    "gift_conf_lv3": "Amor infinito",
    "gift_conf_lv4": "Para siempre",
    "gift_habibi": "Amigo",
    "gift_bestie": "Amiga",
    "gift_couple": "Amor",
    "gift_confidant": "BFF",
    "weding_gift_kiss": "Beso",
    "weding_gift_ring": "Anillo",
    "weding_gift_proposal": "Propuesta de matrimonio",
    "weding_gift_castle": "Castillo",
    "weding_gift_wedding_dress": "Vestido de novia",
    "weding_gift_wedding": "Boda",
    "gift_album_des6": "Reglas",
    "guild_can_with": "",
    "guild_with_ing": "",
    "guild_self_withdraw": "",
    "guild_transfer_to_leader": "",
    "guild_salary_to_reseller": "",
    "guild_convert_to_diamond": "",
    "guild_platform_settlement": "",
    "guild_withdrawal_records": "",
    "guild_current_withdrawable_pcoin": "",
    "guild_transfer_pcoin_amount": "",
    "guild_all": "",
    "guild_read_before_withdraw": "",
    "guild_withdraw_note_1": "",
    "guild_withdraw_note_2": "",
    "guild_min_withdraw_amount": "",
    "guild_withdraw_note_4": "",
    "guild_submit_application": "",
    "guild_withdraw_below_min": "",
    "guild_confirm_submit_application": "",
    "guild_freeze_notice": "",
    "guild_communicate_with_leader": "",
    "guild_cancel": "",
    "guild_confirm": "",
    "guild_withdrawal_method": "",
    "guild_leader_withdraw": "",
    "guild_apply_time": "",
    "guild_process_time": "",
    "guild_rejection_reason": "",
    "guild_amount_refunded": "",
    "guild_status_pending": "",
    "guild_status_completed": "",
    "guild_status_rejected": "",
    "guild_show_last_3_months": "",
    "guild_withdrawal_question": "",
    "guild_contact_customer_service": "",
    "guild_certified_reseller": "",
    "guild_not_reseller_cannot_transfer": "",
    "guild_current_withdrawable": "",
    "guild_transfer_amount": "",
    "guild_estimated_arrival": "",
    "guild_read_before_operation": "",
    "guild_transfer_note_1": "",
    "guild_transfer_note_2": "",
    "guild_confirm_transfer": "",
    "guild_confirm_submit_transfer": "",
    "guild_deduct_pcoin_receive_diamond": "",
    "guild_communicate_with_reseller": "",
    "guild_operation_success": "",
    "guild_exchange_diamond": "",
    "guild_current_exchangeable_pcoin": "",
    "guild_exchange": "",
    "guild_exchange_success": "",
    "guild_settlement_pcoin_amount": "",
    "guild_settlement_note_1": "",
    "guild_settlement_note_2": "",
    "guild_settlement_min_amount": "",
    "guild_application_submitted": "",
    "guild_deduct_pcoin": "",
    "guild_contact_service": ""
}
